import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import CurrentRoleStore from './CurrentRoleStore';
import CurrentUserStore from './CurrentUserStore';


class AdminStore extends ReduceStore {
  getInitialState() {
    return {
      canResetPassword: false,
      canAdministerUsers: false,
      canAdministerResources: false,
    };
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CurrentRoleStore.getDispatchToken(),
      CurrentUserStore.getDispatchToken()]);

    if (CurrentRoleStore.hasChanged() || CurrentUserStore.hasChanged()) {
      return {
        canResetPassword: !!(CurrentUserStore.getState().auth0),
        canAdministerUsers: CurrentRoleStore.isAdmin(),
        canAdministerResources: CurrentRoleStore.isAdmin(),
      };
    }

    return state;
  }

  hasAdminOptions() {
    return this.getState().canResetPassword || this.getState().canAdministerUsers;
  }
}

const instance = new AdminStore(AppDispatcher);
export default instance;
